<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="false"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>直接データ照会</h5>
    <div class="w100 mb-4 pb-3 border-bottom">
      <div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">クラブコード</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="search_club_no"
                class="form-control"
                @change="search_club_from_club_no()"
              />
              <button
                @click="search_club_from_club_no()"
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                検索
              </button>
            </div>
          </div>
          <div class="col-5 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_club_obj.name_1"
              class="form-control"
              placeholder="クラブ名"
              disabled="true"
            />
          </div>
          <div
            class="col-2 mb-2"
            v-if="
              typeof search_club_obj === 'object' &&
              typeof search_club_obj.id === 'string' &&
              search_club_obj.id > 0
            "
          >
            <bs-button
              :btnWrapClass="'d-grid'"
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="handleClick(search_club_obj.id)"
              >照会</bs-button
            >&nbsp;
          </div>
          <div
            class="col-2 mb-2"
            v-else-if="
              typeof search_club_obj === 'object' &&
              typeof search_club_obj.id === 'undefined'
            "
          >
            --
          </div>
        </div>
      </div>
    </div>
    <h5>検索一覧からの照会</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">最終継続年度</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.last_event_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-3 mb-2" v-if="false">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.last_sports_year_higher"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">以降</span>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">名称/カナ</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">名称</span>
              <input
                type="text"
                v-model="sprm.like_name_1"
                class="form-control"
                placeholder="名称"
              />
            </div>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">カナ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_1"
                class="form-control"
                placeholder="カナ"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">地区</p>
          </div>
          <div class="col-4 mb-2">
            <div
              class="w-100 border py-1 px-2"
              style="height: 200px; overflow-y: scroll"
            >
              <div
                v-for="region in region_cd_list"
                :key="region"
                class="mb-2 pb-1 container"
              >
                <div
                  :class="
                    'row py-1 px-2 rounded-1 mb-2 border ' +
                    attach_region_class_label(region.key)
                  "
                >
                  <div class="col-9" @click="attach_region(region.key)">
                    <i :class="attach_region_class_checkbox(region.key)"></i
                    >&nbsp;
                    {{ region.label }}
                  </div>
                  <div
                    class="col-3 text-end"
                    @click="attach_open_region(region.key)"
                  >
                    <i :class="attach_region_class_caret(region.key)"></i>
                  </div>
                </div>
                <div class="ps-3" v-if="chk_include_open_region_cd(region.key)">
                  <div
                    v-for="pref in pref_filter(region.key)"
                    :key="pref"
                    class="d-inline-block p-0 me-1 mb-1"
                  >
                    <label
                      :for="'pref_' + pref.key"
                      :class="
                        'py-1 px-2 rounded-1 text-white ' +
                        attach_pref_class_label(pref.key)
                      "
                      @click="attach_pref(pref.key)"
                    >
                      <i :class="attach_pref_class_checkbox(pref.key)"></i>
                      {{ pref.label }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">活動種目</p>
          </div>
          <div class="col-4 mb-2">
            <div
              class="w-100 border py-1 px-2"
              style="height: 200px; overflow-y: scroll"
            >
              <div class="row">
                <div
                  class="col-6 mb-2"
                  v-for="event in event_cd_list"
                  :key="event"
                >
                  <div class="d-grid">
                    <button
                      :class="event_class(event.id)"
                      @click="toggleEvent(event.id)"
                    >
                      {{ event.label }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- <div v-for="event in event_cd_list" :key="region" class="mb-2 pb-1 container">
                                <div :class="'row py-1 px-2 rounded-1 mb-2 border ' + attach_region_class_label(region.key)" >
                                    <div class="col-9" @click="attach_region(region.key)">
                                        <i :class="attach_region_class_checkbox(region.key)"></i>&nbsp;
                                        {{region.label}}
                                    </div>
                                    <div class="col-3 text-end" @click="attach_open_region(region.key)">
                                        <i :class="attach_region_class_caret(region.key)"></i>
                                    </div>
                                </div>
                                <div class="ps-3" v-if="chk_include_open_region_cd(region.key)">
                                    <div v-for="pref in pref_filter(region.key)" :key="pref" class="d-inline-block p-0 me-1 mb-1">
                                        <label :for="'pref_' + pref.key" :class="'py-1 px-2 rounded-1 text-white ' + attach_pref_class_label(pref.key)" @click="attach_pref(pref.key)">
                                            <i :class="attach_pref_class_checkbox(pref.key)"></i>
                                            {{pref.label}}</label>
                                        </div>
                                </div>
                            </div> -->
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">表示件数</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="get_page_num_list"
              v-model="page_limit"
              :null-option="true"
              id="MainClinicId"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button :btnClass="'btn-primary'" @to_click_event="search_club"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="typeof club_list === 'object' && Object.keys(club_list).length > 0"
    >
      <table class="table mb-4">
        <thead>
          <tr>
            <th>クラブコード</th>
            <th>クラブ名</th>
            <th>クラブ名(カナ)</th>
            <th>責任者</th>
            <th>都道府県</th>
            <th>最終更新年度</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in club_list" :key="list.id">
            <td>{{ list.club_no }}</td>
            <td>{{ list.name_1 }}</td>
            <td>{{ list.yomi_1 }}</td>
            <td>{{ list.name_2 }} {{ list.name_3 }}</td>
            <td>{{ list.pref_label }}</td>
            <td>{{ list.last_event_year }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >照会</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'club'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
        <div class="col-4 text-end">
          <bs-button :btnClass="'btn-warning'" @to_click_event="download"
            >CSVダウンロード</bs-button
          >
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>
<style>
.btn_order {
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
import Common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'
import moment from 'moment'

export default {
  name: 'ClubListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '公認クラブデータ一覧',
      fromParentBtn: 'データ登録',
      club_obj: [],
      search_club_no: '',
      search_club_obj: {},
      sprm: {
        csv_type: '',
        license_no: '',
        like_name: '',
        like_name_1: '',
        like_name_2: '',
        like_yomi_1: '',
        like_yomi_2: '',
        last_event_year: '',
        last_sports_year: '',
        last_sports_year_higher: '',
        last_sports_year_lower: '',
        search_words: '',
        pref_cd: [],
        birth_date: '',
        birth_date_year: '',
        birth_date_month: '',
        birth_date_day: '',
        region_cd: [],
        license_cd: [],
        license_event_cd: [],
        event_cds: [],
        affiliation: ''
      },
      attach_license_event_cd: [],
      open_region_cd: [],
      open_event_cd: [],
      page: 0,
      page_limit: 10,
      page_sort: 'ASC',
      page_order: 'mfj_club_data.club_no',
      target_name: '',
      region_obj: [],
      pref_obj: [],
      license_cd_obj: [],
      license_event_cd_obj: [],
      event_cd_obj: [],
      license_type_obj: [],
      affiliation_type_obj: [],
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    ...mapState({}),
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    affiliation_type_list: function () {
      return this.affiliation_type_obj
    },
    event_list: function () {
      return config.EVENT_CD_LIST
    },
    license_list: function () {
      return config.LICENSE_CD_LIST
    },
    license_filter: function () {
      const license_list = this.license_list
      return function (event_key) {
        return license_list.filter(lc => {
          if (
            typeof lc.groups === 'object' &&
            lc.groups.find(group => group == event_key)
          ) {
            return true
          }
          return false
        })
      }
    },
    get_license_filter_class: function () {
      const license_cd_list = this.license_cd_list
      return function (club_license, license_class) {
        return typeof club_license === 'object'
          ? club_license
              .filter(license => {
                if (
                  typeof license_cd_list.find(
                    license_cd => license_cd.license_cd == license.license_cd
                  ) === 'object' &&
                  license_cd_list.find(
                    license_cd => license_cd.license_cd == license.license_cd
                  ).license_class == license_class
                ) {
                  return true
                }
              })
              .map(license => {
                license.short_label = license_cd_list.find(
                  license_cd => license_cd.license_cd == license.license_cd
                ).short_label
                return license
              })
          : []
      }
    },
    license_event_cd_filter: function () {
      const lists = [...this.license_event_cd_obj]
      const filter = this.license_cd_filter
      return function (license_class) {
        return lists
          .filter(list => {
            if (
              typeof filter(list.license_event_cd, license_class) ===
                'object' &&
              filter(list.license_event_cd, license_class).length > 0
            ) {
              return true
            }
            return false
          })
          .map(list => {
            list.key = list.license_event_cd
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_event_cd_list: function () {
      const lists = [...this.license_event_cd_obj]
      return lists
        .map(list => {
          list.key = list.license_event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists
        .map(list => {
          list.key = list.license_cd
          // list.short_label += '[' + list.license_category + ']';
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.license_category) < parseInt(b.license_category)) {
            return -1
          }
          if (parseInt(a.license_category) > parseInt(b.license_category)) {
            return 1
          }
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          }
          if (parseInt(a.sort) > parseInt(b.sort)) {
            return 1
          }
          return 0
        })
    },
    license_cd_filter: function () {
      const license_cd_list = this.license_cd_list
      const license_type_list = this.license_type_list
      return function (event_cd, license_class) {
        return license_cd_list.filter(license => {
          // console.log('license_cd_filter', event_cd, license_class, license.license_class);
          if (
            typeof license === 'object' &&
            typeof license.license_cd === 'string' &&
            typeof license_type_list === 'object' &&
            license_type_list.find(
              type =>
                type.license_cd == license.license_cd &&
                type.event_cd == event_cd
            ) &&
            license_class != false &&
            license_class != undefined &&
            license.license_class == license_class
          ) {
            return true
          }
          return false
        })
      }
    },
    license_type_list: function () {
      const lists = [...this.license_type_obj]
      return lists
        .map(list => {
          // list.event_label = this.get_event_label(list.event_cd);
          // list.license_label = this.get_license_label(list.license_cd);
          // list.license_short_label = this.get_license_short_label(list.license_cd);
          // list.license_print_label = this.get_license_print_label(list.license_cd);
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },

    // region_list: function(){
    //     return config.AREA_CD_LIST;
    // },
    // pref_list: function(){
    //     return config.PREF_CD_LIST;
    // },
    pref_cd_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.key = list.pref_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_cd_list: function () {
      const lists = [...this.region_obj]
      return lists
        .map(list => {
          list.key = list.region_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    pref_filter: function () {
      const pref_cd_list = this.pref_cd_list
      return function (region_key) {
        return pref_cd_list.filter(pref => pref.region_cd == region_key)
      }
    },
    year_list: function () {
      let now = parseInt(Common.getNowYear()) + 1
      let limit = now - 7
      const tmps = []
      for (let i = now; i > limit; i--) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    birth_date_year_list: function () {
      let now = 1920
      let limit = parseInt(Common.getNowYear()) + 1
      const tmps = []
      for (let i = now; i < 1970; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      tmps.push({
        key: '',
        label: '選択して下さい'
      })
      for (let i = 1970; i < limit; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_month_list: function () {
      const tmps = []
      for (let i = 1; i <= 12; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_day_list: function () {
      // const moment_date = moment();
      const moment_func = moment
      return function (year, month) {
        let max = 31
        if (year != '' && month != '') {
          const moment = moment_func([year, parseInt(month) - 1, 1])
          max = moment.daysInMonth()
        }
        const tmps = []
        for (let i = 1; i <= max; i++) {
          tmps.push({
            key: i,
            label: i
          })
        }
        return tmps
      }
    },
    club_list: function () {
      const lists = [...this.club_obj]
      lists.map(list => {
        // list['name_label'] = (list.name_1)? list.name_1: '';
        // list['name_label'] += (list.name_2)? list.name_2: '';
        // list['name_label'] += (list.name_3)? list.name_3: '';

        // list['main_clinic_label'] = this.get_clinic_label(list.main_clinic_id);
        return list
      })
      return lists
    },
    get_clinic_data: function () {
      const clinic_list = this.clinic_list
      return function (clinic_id) {
        return clinic_list.find(clinic => {
          return clinic.id == clinic_id
        })
      }
    },
    get_clinic_label: function () {
      const get_clinic_data = this.get_clinic_data
      return function (clinic_id) {
        return typeof get_clinic_data(clinic_id) === 'object'
          ? get_clinic_data(clinic_id).label
          : '-'
      }
    },
    // event
    event_class: function () {
      const sprm_event = this.sprm.event_cds
      return function (event_cd) {
        if (sprm_event.indexOf(event_cd) > -1) {
          return 'btn btn-primary btn-sm'
        } else {
          return 'btn btn-sm btn-light btn-outline-secondary'
        }
      }
    },
    chk_include_event_cd: function () {
      const attach_license_event_cd = this.attach_license_event_cd
      return function (license_event_cd, license_class) {
        // console.log(license_class);
        if (
          attach_license_event_cd.find(
            lc =>
              lc.license_event_cd == license_event_cd &&
              parseInt(lc.license_class) == parseInt(license_class)
          )
        ) {
          return true
        }
        return false
      }
    },
    attach_event_class_label: function () {
      const chk_comp = this.chk_include_event_cd
      return function (event_cd, license_class) {
        if (chk_comp(event_cd, license_class)) {
          return 'text-white bg-primary border border-primary'
        }
        return 'text-dark bg-light border border-secondary'
      }
    },
    attach_event_class_checkbox: function () {
      const chk_comp = this.chk_include_event_cd
      return function (event_cd, license_class) {
        if (chk_comp(event_cd, license_class)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },
    chk_include_open_event_cd: function () {
      const open_event_cd = this.open_event_cd
      return function (license_event_cd, license_class) {
        if (
          open_event_cd.find(
            cd =>
              cd.license_event_cd == license_event_cd &&
              cd.license_class == license_class
          )
          // open_event_cd.indexOf(event_cd) > -1
        ) {
          return true
        }
        return false
      }
    },
    attach_event_class_caret: function () {
      const chk_comp = this.chk_include_open_event_cd
      return function (event_cd, license_class) {
        if (chk_comp(event_cd, license_class)) {
          return 'bi-caret-up-fill'
        }
        return 'bi-caret-down-fill'
      }
    },

    // license
    chk_include_license_cd: function () {
      const sprm_license = this.sprm.license_cd
      return function (license_cd) {
        if (sprm_license.indexOf(license_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_license_class_label: function () {
      const chk_comp = this.chk_include_license_cd
      return function (license_cd) {
        if (chk_comp(license_cd)) {
          return 'bg-primary'
        }
        return 'bg-secondary'
      }
    },
    attach_license_class_checkbox: function () {
      const chk_comp = this.chk_include_license_cd
      return function (license_cd) {
        if (chk_comp(license_cd)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },

    // region
    chk_include_region_cd: function () {
      const sprm_region = this.sprm.region_cd
      return function (region_cd) {
        if (sprm_region.indexOf(region_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_region_class_label: function () {
      const chk_comp = this.chk_include_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'text-white bg-primary border border-primary'
        }
        return 'text-dark bg-light border border-secondary'
      }
    },
    attach_region_class_checkbox: function () {
      const chk_comp = this.chk_include_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },
    chk_include_open_region_cd: function () {
      const open_region_cd = this.open_region_cd
      return function (region_cd) {
        if (open_region_cd.indexOf(region_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_region_class_caret: function () {
      const chk_comp = this.chk_include_open_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'bi-caret-up-fill'
        }
        return 'bi-caret-down-fill'
      }
    },

    // pref
    chk_include_pref_cd: function () {
      const sprm_pref = this.sprm.pref_cd
      return function (pref_cd) {
        if (sprm_pref.indexOf(pref_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_pref_class_label: function () {
      const chk_comp = this.chk_include_pref_cd
      return function (pref_cd) {
        if (chk_comp(pref_cd)) {
          return 'bg-primary'
        }
        return 'bg-secondary'
      }
    },
    attach_pref_class_checkbox: function () {
      const chk_comp = this.chk_include_pref_cd
      return function (pref_cd) {
        if (chk_comp(pref_cd)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    }
  },

  async created() {
    await this.loadEventCdList()
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    await this.loadLicenseTypeList()
    await this.loadRegionList()
    await this.loadPrefList()
    await this.loadAffiliationTypeList()
    await this.loadSearchParam()
    await this.loadClubList(false)
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '公認クラブデータ一覧です。'
  },

  methods: {
    // event
    async toggleEvent(event_cd) {
      const tmps = [...this.sprm.event_cds]
      if (tmps.indexOf(event_cd) > -1) {
        const index = tmps.findIndex(obj => obj == event_cd)
        tmps.splice(index, 1)
      } else {
        tmps.push(event_cd)
      }
      this.sprm.event_cds = tmps
    },
    attach_open_event(license_event_cd, license_class) {
      const tmps =
        typeof this.open_event_cd === 'object' ? [...this.open_event_cd] : []
      if (this.chk_include_open_event_cd(license_event_cd, license_class)) {
        const tmps_index = tmps.findIndex(
          tmp =>
            tmp.license_event_cd == license_event_cd &&
            tmp.license_class == license_class
        )
        tmps.splice(tmps_index, 1)
      } else {
        tmps.push({
          license_event_cd: license_event_cd,
          license_class: license_class
        })
      }

      // if(
      //     tmps.indexOf(license_event_cd) > -1
      // ){
      //     tmps.splice(tmps.indexOf(license_event_cd), 1);
      // }
      // else{
      //     tmps.push(license_event_cd);
      // }

      this.open_event_cd = tmps
    },
    attach_event(license_event_cd, license_class) {
      console.log(
        'attach_event',
        license_event_cd,
        license_class,
        this.chk_include_event_cd(license_event_cd, license_class)
      )
      if (
        this.chk_include_open_event_cd(license_event_cd, license_class) ===
        false
      ) {
        this.attach_open_event(license_event_cd, license_class)
      }
      const tmps =
        typeof this.attach_license_event_cd === 'object'
          ? [...this.attach_license_event_cd]
          : []

      // ON→OFF
      if (
        this.chk_include_event_cd(license_event_cd, license_class)
        // tmps.indexOf(license_event_cd) > -1
      ) {
        const lc_cd = [...this.sprm.license_cd]
        this.sprm.license_cd = lc_cd.filter(lc => {
          if (
            typeof this.license_cd_filter(license_event_cd, license_class) ===
              'object' &&
            this.license_cd_filter(license_event_cd, license_class).find(
              chk => chk.license_cd == lc
            )
          ) {
            return false
          }
          return true
        })
        this.attach_license_event_cd = tmps.filter(tmp => {
          if (
            tmp.license_event_cd == license_event_cd &&
            parseInt(tmp.license_class) == parseInt(license_class)
          ) {
            return false
          }
          return true
        })
      }
      // OFF→ON
      else {
        tmps.push({
          license_class: license_class,
          license_event_cd: license_event_cd
        })
        this.attach_license_event_cd = tmps

        if (
          typeof this.license_cd_filter(license_event_cd, license_class) ===
          'object'
        ) {
          this.license_cd_filter(license_event_cd, license_class).forEach(
            license => {
              if (
                this.chk_include_event_cd(license.event_cd, license_class) ===
                  false &&
                this.sprm.license_cd.includes(license.license_cd) === false
              ) {
                this.attach_license(
                  license.license_cd,
                  license_event_cd,
                  license_class
                )
              }
            }
          )
        }
      }
      this.$forceUpdate()
    },

    // license
    attach_license(license_cd, license_event_cd, license_class) {
      console.log('attach_license license_cd', license_cd, license_class)
      const tmps =
        typeof this.sprm.license_cd === 'object'
          ? [...this.sprm.license_cd]
          : []
      if (tmps.indexOf(license_cd) > -1) {
        console.log('attach_license nashi')
        tmps.splice(tmps.indexOf(license_cd), 1)
        if (
          this.chk_include_event_cd(license_event_cd, license_class) === true
        ) {
          const event_tmp = [...this.attach_license_event_cd]
          const lc_index = event_tmp.findIndex(
            lc =>
              lc.license_event_cd == license_event_cd &&
              lc.license_class == license_class
          )
          event_tmp.splice(lc_index, 1)
          this.attach_license_event_cd = event_tmp
        }
      } else {
        tmps.push(license_cd)
        console.log(
          'attach_license ari',
          tmps.length,
          this.license_cd_filter(license_event_cd, license_class).length
        )

        if (
          (
            tmps.filter(lc => {
              if (
                this.license_cd_filter(license_event_cd, license_class).find(
                  lcd => lcd.license_cd == lc
                )
              ) {
                return true
              }
              return false
            }) || []
          ).length ==
          this.license_cd_filter(license_event_cd, license_class).length
        ) {
          const event_tmp = [...this.attach_license_event_cd]
          event_tmp.push({
            license_event_cd: license_event_cd,
            license_class: license_class
          })
          this.attach_license_event_cd = event_tmp
        }
        // if(
        //     tmps.filter(
        //         (license) => {
        //             if(
        //                 this.license_type_list.find(
        //                     (tp) => (tp.license_cd == license && tp.event_cd == license_event_cd && tp.license_class == license_class)
        //                 )
        //             ){
        //                 return true;
        //             }
        //             return false
        //         }).length == this.license_cd_filter(license_event_cd, license_class).length
        //     && this.chk_include_event_cd(license_event_cd, license_class) === false
        // ){
        //     const event_tmp = [...this.attach_license_event_cd];
        //     event_tmp.push({
        //         license_event_cd: license_event_cd,
        //         license_class: license_class
        //     });
        //     this.attach_license_event_cd = event_tmp;
        // }
      }
      this.sprm.license_cd = tmps
      this.$forceUpdate()
    },

    // region
    attach_open_region(region_cd) {
      const tmps =
        typeof this.open_region_cd === 'object' ? [...this.open_region_cd] : []
      if (tmps.indexOf(region_cd) > -1) {
        tmps.splice(tmps.indexOf(region_cd), 1)
      } else {
        tmps.push(region_cd)
      }
      this.open_region_cd = tmps
    },
    attach_region(region_cd) {
      if (this.chk_include_open_region_cd(region_cd) === false) {
        this.attach_open_region(region_cd)
      }
      const tmps =
        typeof this.sprm.region_cd === 'object' ? [...this.sprm.region_cd] : []
      if (tmps.indexOf(region_cd) > -1) {
        tmps.splice(tmps.indexOf(region_cd), 1)
        this.sprm.pref_cd = []
      } else {
        tmps.push(region_cd)
        if (typeof this.pref_filter(region_cd) === 'object') {
          this.pref_filter(region_cd).forEach(pref => {
            if (this.chk_include_pref_cd(pref.key) === false) {
              this.attach_pref(pref.key)
            }
          })
        }
      }
      this.sprm.region_cd = tmps
    },
    // pref
    attach_pref(pref_cd) {
      const tmps =
        typeof this.sprm.pref_cd === 'object' ? [...this.sprm.pref_cd] : []
      const tmp_grp = this.pref_cd_list.find(
        pref => pref.key == pref_cd
      ).region_cd
      if (tmps.indexOf(pref_cd) > -1) {
        tmps.splice(tmps.indexOf(pref_cd), 1)
        if (this.chk_include_region_cd(tmp_grp) === true) {
          const region_tmp = [...this.sprm.region_cd]
          region_tmp.splice(region_tmp.indexOf(tmp_grp), 1)
          this.sprm.region_cd = region_tmp
        }
      } else {
        tmps.push(pref_cd)
        if (
          tmps.filter(pref => {
            const get_tp = this.pref_cd_list.find(tp => tp.key == pref)
            if (get_tp.region_cd == tmp_grp) {
              return true
            }
            return false
          }).length == this.pref_filter(tmp_grp).length &&
          this.chk_include_region_cd(tmp_grp) === false
        ) {
          const region_tmp = [...this.sprm.region_cd]
          region_tmp.push(tmp_grp)
          this.sprm.region_cd = region_tmp
        }
      }
      this.sprm.pref_cd = tmps
    },

    go_consulting(target) {
      this.$router.push({
        // name: 'process_detail',
        path: '/consulting/add',
        query: {
          m_id: target
        }
      })
    },
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.cate_obj.find(cate => {
          return cate.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'club' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadCateList()
          })
      }
    },
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('club') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },

    async download() {
      await this.loadClubList('csv')
    },
    async search_club_from_club_no() {
      console.log(
        'search_club_from_club_no',
        this.search_club_no,
        typeof this.search_club_no
      )
      await this.loadClubList(this.search_club_no)
    },
    async sort_order(order, sort) {
      this.page_order = order ? order : 'id'
      this.page_sort = sort ? sort : 'ASC'

      await this.loadClubList(false)
    },
    async search_club() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadClubList(false)
      } finally {
        this.isLoading = false
      }
    },
    async loadClubList(flg) {
      const params = {}
      params['stat'] = [1]

      let post_url = config.BASE_API_URL
      if (flg == 'csv') {
        post_url += '/club/output_csv'
        if (typeof this.sprm === 'object') {
          Object.keys(this.sprm).forEach(sprm_key => {
            if (this.sprm[sprm_key] != '') {
              params[sprm_key] = this.sprm[sprm_key]
            }
          })
        }
        params['pagegroup'] = 'mfj_club_data.id'
        params['pagelimit'] = false
        params['p'] = 0
      } else if (flg !== false) {
        post_url += '/club/lists'
        params['club_no_bw'] = flg
        params['pagegroup'] = 'mfj_club_data.id'
      } else {
        post_url += '/club/lists'
        if (typeof this.sprm === 'object') {
          Object.keys(this.sprm).forEach(sprm_key => {
            if (this.sprm[sprm_key] != '') {
              params[sprm_key] = this.sprm[sprm_key]
            }
          })
        }
        params['pagelimit'] = this.page_limit
        if (this.page >= 0) params['p'] = this.page
        params['pagegroup'] = 'mfj_club_data.id'
        params['pageorder'] = this.page_order
        params['pagesort'] = this.page_sort
        this.$store.dispatch('setSearchParam', {
          data: params,
          target: 'club'
        })
      }

      await this.basicPosts_S(post_url, params)
        .then(async response => {
          if (flg == 'csv') {
            console.log('loadClubList download response', response)
            window.open(
              config.BASE_API_URL + '/club/download?file=' + response.data.body,
              '_blank'
            )
          } else if (flg !== false) {
            console.log('loadClubList response', response)
            const tmp_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            let name_label = ''
            console.log('loadClubList response tmp_obj', tmp_obj)
            if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
            if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
            if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
            tmp_obj.name_label = name_label
            console.log('loadClubList response tmp_obj', tmp_obj)
            this.search_club_obj = tmp_obj
          } else {
            console.log('loadClubList response', response)
            this.club_obj =
              response.data && response.data.body ? response.data.body : []
            this.$store.dispatch('setSearchParam', {
              data: params,
              target: 'club'
            })
            const setPageData = {}
            setPageData.data =
              response.data && response.data.pager ? response.data.pager : {}
            setPageData.target = 'club'
            this.$store.dispatch('setPager', setPageData)
          }
        })
        .catch(async err => {
          console.log(err)
          if (!flg) this.club_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'club'
      })
    },
    handleClick(target) {
      this.$router.push({ path: '/club/' + target + '/' })
    },
    async pageAction(page) {
      this.page = page
      await this.loadClubList(false)
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseTypeList response', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadAffiliationTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/affiliation_type',
        params
      )
        .then(async response => {
          console.log('loadAffiliationTypeList response', response)
          this.affiliation_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.affiliation_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async initialLoad() {
      this.page = 0
      await this.loadClubList(false)
    }
  }
}
</script>
